import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { KeyRound, ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function ForcePasswordChangeDialog() {
  const { user, checkSession } = useAuth();
  const [cur, setCur] = useState("psa2025");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [busy, setBusy] = useState(false);

  const open = !!(user && user.must_change_password);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (nw !== nw2) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password updated — welcome aboard.");
      await checkSession();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to change password");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-md" data-testid="force-password-dialog" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldAlert className="w-5 h-5 text-amber-500" /> Password Change Required</DialogTitle>
          <DialogDescription>
            Your account is using the default password. For security, please set a new password before continuing.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>Current password</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="font-mono" data-testid="fpc-current" />
          </div>
          <div>
            <Label>New password</Label>
            <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="fpc-new" />
          </div>
          <div>
            <Label>Confirm new password</Label>
            <Input type="password" value={nw2} onChange={(e) => setNw2(e.target.value)} data-testid="fpc-confirm" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={busy} className="w-full font-mono tracking-widest" data-testid="fpc-submit">
              <KeyRound className="w-4 h-4 mr-2" /> {busy ? "Saving…" : "Set New Password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
